import React, { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSyncMsalWithStore } from '@/hooks/syncMsalWithStore';
import { getAppTheme } from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import getRouter from './routes';
import { logApplicationError } from '@/utils/safeErrorMessage';

if (typeof window !== 'undefined') {
	window.addEventListener('error', (event) => {
		logApplicationError('window.error', {
			message: event.message,
			stack: event.error?.stack,
			filename: event.filename,
			lineno: event.lineno,
			colno: event.colno,
		});
	});

	window.addEventListener('unhandledrejection', (event) => {
		const reason = event.reason;
		logApplicationError('unhandledrejection', {
			message: reason?.message ?? String(reason),
			stack: reason?.stack,
		});
	});
}

const router = getRouter();

const App = () => {
	// Sync MSAL account with Redux storeuseSyncMsalWithStore();
	useSyncMsalWithStore();

	const themeMode = useSelector((state) => state.userPrefs.themeMode);
	const theme = useMemo(() => getAppTheme(themeMode), [themeMode]);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<RouterProvider router={router} />
		</ThemeProvider>
	);
};

App.displayName = 'App';

export default App;
